/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

/**
 * Kinds of Aggregate that can be used.
 */
export type NebulyAggregateKind = (typeof NebulyAggregateKind)[keyof typeof NebulyAggregateKind];

export const NebulyAggregateKind = {
  topic: 'topic',
  model_classes: 'model_classes',
  moderation_classes: 'moderation_classes',
  business_classes: 'business_classes',
} as const;
